import Vue from 'vue';
import Robot2 from "./components/Robot2";
Vue.use(require('vue-cookie'));
import axios from 'axios';
Vue.prototype.$http = axios;

let el = document.getElementById('robot-container')

if(el) {
    let robot = new Vue({
        el: '#robot-container',
        components: {
            Robot2: Robot2
        },
        data: () => ({

        }),
        mounted: function () {
            // this.showKeyIn()
        },
        methods: {
            displayStatus: function (msg, type) {
                // this.$toastr.defaultPosition = "toast-top-right";
                // this.$toastr.defaultClassNames = 'alert';
                //
                // if (type == 'w') {
                //     this.$toastr.w(msg);
                // } else if (type == 's') {
                //     this.$toastr.s(msg);
                // } else if (type == 'e') {
                //     this.$toastr.w(msg);
                // } else {
                //     this.$toastr.i(msg);
                // }
            },
            showKeyIn: function() {
                // $('#keyInModal').modal({
                //     show: true,
                //     keyboard: false,
                // });
                // setTimeout(function(){
                //     //console.log('focusing verify pin');
                //     $('#verify_pin').focus().select();
                // }, 600);
            },
            checkPin: function() {
                // console.log('checking pin...');
                // let that = this;
                // this.$http.post('/api/v1/private/sale/pin/', {
                //     user_id: $('#verify_user_id').val(),
                //     pin: $('#verify_pin').val(),
                // }).then(
                //     (response) => {
                //         console.log(response.data);
                //         if(response.data.error == null){
                //             $('#keyInModal').modal('hide');
                //             that.$cookie.set('cashier_id', response.data.id, {secure: true});
                //             that.$cookie.set('cashier_name', response.data.first_name + ' ' + response.data.last_name.charAt(0), {secure: true});
                //             that.displayStatus('Successfully keyed in.', 'success');
                //             that.loading = false;
                //         }else{
                //             //console.log('error keying in:');
                //             that.displayStatus('Error keying in. Please check that you have selected the correct user, re-enter your pin and try again. If this error continues, contact support.', 'warn');
                //             that.loading = false;
                //         }
                //     },
                //     (response) =>
                //     {
                //         //console.log('error keying in:');
                //         that.displayStatus('Error keying in. Please check that you have selected the correct user, re-enter your pin and try again. If this error continues, contact support.', 'warn');
                //         that.loading = false;
                //     });
            },
            cancelKeyIn: function() {
                // window.location = '/dashboard';
            }
        }
    });
}
